import FormInputAddon from './formInputAddon-TEMPLATE_VERSION'

export default FormInputAddon
